/**
 * Created by ChrisMuto on 6/28/17.
 */
import * as configureWevoActions from "./actions";
import configureWevoReducers from "./reducers";
import * as configureWevoTypes from "./types";
import * as configureWevoConstants from "./constants";

export {
    configureWevoConstants,
    configureWevoActions,
    configureWevoReducers,
    configureWevoTypes
};

export default configureWevoReducers;



// WEBPACK FOOTER //
// ./src/modules/configure-wevo/index.js